var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeasureSwitcher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 164.60172,
    height: 164.60172,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.60172 164.60172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -676.68994,
    y1: -1022.3813,
    x2: -707.20804,
    y2: -1022.3813,
    gradientTransform: "translate(-1159.73496 57.76262) rotate(134.533) scale(1.12 .879)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2335.35025,
    y1: -1717.86713,
    x2: -2365.86772,
    y2: -1717.86713,
    gradientTransform: "translate(-791.63979 -2893.42475) rotate(-135.467) scale(1.12 .87901)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -6.35307,
    y: -2.39385,
    width: 170.95479,
    height: 168.99335,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xeqcy3oqbc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.66342,153.08989l-7.27334-7.27334,63.65972-63.65972L42.80673,18.91377l7.27334-7.27334,70.51641,70.51641s-70.93306,70.93306-70.93306,70.93305Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.84712,152.87385l-7.27334-7.27334,63.44367-63.44367L6.78468,18.92405l7.27334-7.27334,70.50612,70.50612L13.84712,152.87385Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75319,128.7957l-25.06061,25.47212-12.89552-12.68977,25.06061-25.47212s12.89552,12.68976,12.89552,12.68977Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.96728,154.27297l12.32653-12.32653,12.32653,12.32653-12.32653,12.32653-12.32653-12.32653Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.44922,47.32814L5.9771,22.26753l12.68462-12.89552,25.47212,25.06061-12.68976,12.89552h.00514Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97346-2.39385l12.32653,12.32653-12.32653,12.32653L-6.35307,9.93268,5.97346-2.39385Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 82.30086,
    x2: 164.60172,
    y2: 82.30086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8100e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09285,
    stopColor: "#6b12e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26122,
    stopColor: "#4a2fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43437,
    stopColor: "#3045f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61198,
    stopColor: "#1d55fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79671,
    stopColor: "#125efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f62fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 78.66419,
    y1: 82.09511,
    x2: 156.64941,
    y2: 82.09511,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Velocity"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h164.60172v164.60172H0V0Z",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.05584,152.7504l-7.27334-7.27334,63.32022-63.32023-63.43853-63.43853,7.27334-7.27848,70.71187,70.71702-70.59357,70.59356Z",
    fill: "url(#linear-gradient-4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureSwitcher);
export default __webpack_public_path__ + "static/media/measure_switcher.3f1a985144c8b5a99d41d37490e270f4.svg";
export { ForwardRef as ReactComponent };